import React from 'react';
import {Typography} from "@mui/joy";
import Box from "@mui/material/Box";
import {InstalledBaseNode} from "../../codegen/graphql";
import NodeLabel from "./nodeLabel";

interface Props {
    /** Fixed leading text, e.g. "Create node under", "Edit", "Delete". Never truncated. */
    prefix: string;
    node: InstalledBaseNode;
    labelType?: "title" | "nodeType";
    /**
     * Upper bound for the title row so it stays on one line and the node name can ellipsize.
     * The header is rendered by the external BasicModalContent, whose flex containers lack
     * `min-width: 0`, so ellipsis can only trigger if we cap our own width. Default fits the
     * ~600px modal (content minWidth 600 + Dialog maxWidth 'sm') minus padding + close/back
     * buttons. Pass a smaller value for narrower modals (e.g. the 500px delete modal).
     */
    maxWidth?: number | string;
}

const NodeModalTitle = ({prefix, node, labelType, maxWidth = 'calc(600px - 130px)'}: Props) => {
    return (
        <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', minWidth: 0, overflow: 'hidden', maxWidth}}>
            <Typography level={'titleSmallLight'} sx={{flexShrink: 0, whiteSpace: 'nowrap'}}>{prefix}</Typography>
            <NodeLabel node={node} style={{marginLeft: '8px', minWidth: 0}} labelType={labelType}/>
        </Box>
    );
};

export default NodeModalTitle;
